<template>
  <div class="modal fade" id="add-profile" tabindex="-1" aria-hidden="true">
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-simple modal-upgrade-plan"
    >
      <div class="modal-content">
        <div class="modal-body">
          <LoadingElement v-if="loading" />
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            id="add-profile-close"
            aria-label="Close"
          ></button>

          <div class="bs-stepper wizard-vertical-icons-example mt-2">
            <div class="bs-stepper-header">
              <div
                @click.prevent="goStep(1)"
                class="step"
                role="button"
                data-target="#general-info"
              >
                <button type="button" class="step-trigger">
                  <span class="bs-stepper-circle">
                    <i class="ti ti-info-circle"></i>
                  </span>
                  <span class="bs-stepper-label">
                    <span class="bs-stepper-title">{{
                      $t("profiles.general_info")
                    }}</span>
                    <span class="bs-stepper-subtitle">{{
                      $t("profiles.add_general_info")
                    }}</span>
                  </span>
                </button>
              </div>
              <div class="line"></div>
              <div
                @click.prevent="goStep(2)"
                class="step"
                role="button"
                data-target="#profile-details"
              >
                <button type="button" class="step-trigger">
                  <span class="bs-stepper-circle">
                    <i class="ti ti-database-exclamation"></i>
                  </span>
                  <span class="bs-stepper-label">
                    <span class="bs-stepper-title">{{
                      $t("profiles.profile_details")
                    }}</span>
                    <span class="bs-stepper-subtitle">{{
                      $t("profiles.setup_profile_details")
                    }}</span>
                  </span>
                </button>
              </div>
              <div class="line"></div>
              <div
                @click.prevent="goStep(3)"
                class="step"
                role="button"
                data-target="#other-info"
              >
                <button type="button" class="step-trigger">
                  <span class="bs-stepper-circle"
                    ><i class="ti ti-adjustments-cog"></i>
                  </span>
                  <span class="bs-stepper-label">
                    <span class="bs-stepper-title">{{
                      $t("profiles.other_info")
                    }}</span>
                    <span class="bs-stepper-subtitle">{{
                      $t("profiles.add_more_info")
                    }}</span>
                  </span>
                </button>
              </div>
            </div>
            <div class="bs-stepper-content">
              <form onSubmit="return false">
                <!-- Personal Info -->
                <div id="general-info" class="content">
                  <div class="row g-6">
                    <div class="col-sm-6">
                      <label class="form-label" for="">{{
                        $t("profiles.name")
                      }}</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="profile.name"
                        @input="validate"
                        oninput="this.value=this.value.replace(/[^a-zA-Z0-9_.\-@\s]/g,'');"
                        dir="auto"
                        :placeholder="$t('profiles.name')"
                        :class="{ 'is-invalid': errors.name }"
                      />
                      <div v-if="errors.name" class="invalid-feedback">
                        {{ errors.name }}
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <label class="form-label" for="">{{
                        $t("profiles.status")
                      }}</label>
                      <label class="switch switch-square switch-lg">
                        <input
                          v-model="profile.enabled"
                          type="checkbox"
                          class="switch-input"
                        />
                        <span class="switch-toggle-slider">
                          <span class="switch-on">
                            <p>{{ $t("profiles.enabled") }}</p>
                          </span>
                          <span class="switch-off">
                            <p>{{ $t("profiles.disabled") }}</p>
                          </span>
                        </span>
                      </label>
                    </div>
                    <div class="col-sm-12">
                      <label class="form-label" for="selectpickerBasic1">{{
                        $t("profiles.service")
                      }}</label>
                      <select
                        id="selectpickerBasic1"
                        class="form-select w-100"
                        data-style="btn-default"
                        v-model="profile.service"
                        @change="validate"
                      >
                        <option value="any">{{ $t("control.any") }}</option>
                        <option value="hostspot">{{
                          $t("control.hotspot")
                        }}</option>
                        <option value="ppp">{{ $t("control.ppp") }}</option>
                      </select>
                    </div>
                    <div class="col-sm-6">
                      <label class="form-label" for="">{{
                        $t("profiles.price")
                      }}</label>
                      <input
                        type="number"
                        v-model="profile.price"
                        class="form-control"
                        placeholder="Price"
                        @input="validate"
                      />
                    </div>
                    <div class="col-sm-6">
                      <label class="form-label" for="">{{
                        $t("profiles.type")
                      }}</label>
                      <select
                        v-model="profile.type"
                        class="form-select w-100"
                        data-style="btn-default"
                        @change="validate"
                      >
                        <option value="subscribtion">{{
                          $t("control.subscribtion")
                        }}</option>
                        <option value="prepaid">{{
                          $t("control.prepaid")
                        }}</option>
                      </select>
                    </div>
                    <div class="col-12">
                      <div class="input-group">
                        <span class="input-group-text">{{
                          $t("profiles.description")
                        }}</span>
                        <textarea
                          v-model="profile.description"
                          class="form-control"
                          dir="auto"
                        ></textarea>
                      </div>
                    </div>
                    <div class="col-12 d-flex justify-content-between">
                      <button class="btn btn-label-secondary btn-prev" disabled>
                        <i class="ti ti-arrow-left ti-xs me-sm-2"></i>
                        <span class="align-middle d-sm-inline-block d-none">{{
                          $t("control.previous")
                        }}</span>
                      </button>
                      <div class="d-flex gap-x-2">
                        <button
                          @click.prevent="store"
                          :disabled="!validated"
                          class="btn btn-success"
                          v-if="profile.id"
                        >
                          <span
                            class="align-middle d-sm-inline-block d-none me-sm-2"
                            >{{ $t("control.save_and_close") }}</span
                          >
                          <i class="ti ti-check ti-xs"></i>
                        </button>
                        <button
                          @click.prevent="nextStep"
                          class="btn btn-primary btn-next"
                        >
                          <span
                            class="align-middle d-sm-inline-block d-none me-sm-2"
                            >{{ $t("control.next") }}</span
                          >
                          <i class="ti ti-arrow-right ti-xs"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Account Details -->
                <div id="profile-details" class="content">
                  <div class="row g-6">
                    <div class="col-sm-12">
                      <label class="form-label" for="">{{
                        $t("profiles.speed_limit")
                      }}</label>
                      <div class="row">
                        <div class="col-sm-6">
                          <div
                            class="form-check custom-option custom-option-basic"
                          >
                            <label
                              class="form-check-label custom-option-content"
                              for="limitedspeed"
                            >
                              <input
                                name="speedlimit"
                                v-model="unlimited_speed"
                                class="form-check-input"
                                type="radio"
                                :value="false"
                                id="limitedspeed"
                                @input="validate"
                              />
                              <span class="custom-option-header">
                                <span class="h6 mb-0 d-flex align-items-center"
                                  ><i class="ti ti-infinity-off me-1"></i
                                  >{{ $t("profiles.limited_speed") }}</span
                                >
                              </span>
                            </label>
                          </div>
                        </div>
                        <div class="col-sm-6 mt-2 mt-md-0">
                          <div
                            class="form-check custom-option custom-option-basic"
                          >
                            <label
                              class="form-check-label custom-option-content"
                              for="umlimitedspeed"
                            >
                              <input
                                v-model="unlimited_speed"
                                name="speedlimit"
                                class="form-check-input"
                                type="radio"
                                :value="true"
                                id="umlimitedspeed"
                                @input="validate"
                              />
                              <span class="custom-option-header">
                                <span class="h6 mb-0 d-flex align-items-center"
                                  ><i class="ti ti-infinity me-1"></i
                                  >{{ $t("profiles.unlimited_speed") }}</span
                                >
                              </span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div v-if="!unlimited_speed" class="col-sm-12">
                      <label class="form-label" for="">{{
                        $t("profiles.download_speed")
                      }}</label>
                      <div class="row">
                        <div class="col-sm-6 mb-2">
                          <input
                            type="number"
                            class="form-control"
                            id="basic-url31"
                            aria-describedby="basic-addon34"
                            :placeholder="$t('profiles.download_speed')"
                            v-model="profile.download_rate_kb"
                            :class="{ 'is-invalid': errors.download }"
                            @input="validate"
                          />
                          <div v-if="errors.download" class="invalid-feedback">
                            {{ errors.download }}
                          </div>
                        </div>
                        <div class="col-sm-6 ">
                          <select
                            id="selectpickerBasic2"
                            class="form-select w-100"
                            data-style="btn-default"
                            v-model="download_rate_limit_factor"
                            @change="validate"
                          >
                            <option value="1">Kb/s</option>
                            <option value="1024">Mb/s</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div v-if="!unlimited_speed" class="col-sm-12 mt-md-0 mt-3">
                      <label class="form-label" for="">{{
                        $t("profiles.upload_speed")
                      }}</label>
                      <div class="row">
                        <div class="col-sm-6 mb-2">
                          <input
                            type="number"
                            class="form-control"
                            id="basic-url32"
                            aria-describedby="basic-addon34"
                            :placeholder="$t('profiles.upload_speed')"
                            v-model="profile.upload_rate_kb"
                            :class="{ 'is-invalid': errors.upload }"
                            @input="validate"
                          />
                          <div v-if="errors.upload" class="invalid-feedback">
                            {{ errors.upload }}
                          </div>
                        </div>
                        <div class="col-sm-6">
                          <select
                            id="selectpickerBasic3"
                            class="form-select w-100"
                            data-style="btn-default"
                            v-model="upload_rate_limit_factor"
                            @change="validate"
                          >
                            <option value="1">Kb/s</option>
                            <option value="1024">Mb/s</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div class="col-12">
                      <div class="input-group">
                        <span class="input-group-text">{{
                          $t("profiles.expiration_date")
                        }}</span>
                        <div class="input-group-text">
                          <input
                            class="form-check-input mt-0"
                            type="checkbox"
                            v-model="profile.has_expiration"
                            aria-label="Checkbox for following text input"
                            @input="validate"
                          />
                        </div>
                        <input
                          type="number"
                          class="form-control"
                          aria-label="Text input with checkbox"
                          placeholder="Duration"
                          v-model="profile.expiration_value"
                          @input="validate"
                          :disabled="!profile.has_expiration"
                        />
                        <select
                          id="selectpickerBasic4"
                          class="form-select"
                          data-style="btn-default"
                          v-model="profile.expiration_unit"
                          @change="validate"
                          :disabled="!profile.has_expiration"
                        >
                          <option value="months">{{
                            $t("profiles.unit.months")
                          }}</option>
                          <option value="days">{{
                            $t("profiles.unit.days")
                          }}</option>
                          <option value="hours">{{
                            $t("profiles.unit.hours")
                          }}</option>
                        </select>
                      </div>
                    </div>

                    <div class="col-12">
                      <div class="input-group">
                        <span class="input-group-text">{{
                          $t("profiles.limited_quota")
                        }}</span>
                        <div class="input-group-text">
                          <input
                            class="form-check-input mt-0"
                            type="checkbox"
                            v-model="profile.traffic_limited"
                            aria-label="Checkbox for following text input"
                          />
                        </div>
                        <input
                          type="number"
                          class="form-control"
                          aria-label="Text input with checkbox"
                          placeholder="Quota size"
                          v-model="profile.traffic_limit_value_mb"
                          @input="validate"
                          :disabled="!profile.traffic_limited"
                        />
                        <select
                          id="selectpickerBasic5"
                          class="form-select"
                          data-style="btn-default"
                          v-model="limit_factor"
                          @change="validate"
                          :disabled="!profile.traffic_limited"
                        >
                          <option value="1">MB</option>
                          <option value="1024">GB</option>
                        </select>
                      </div>
                    </div>

                    <div class="col-sm-12">
                      <label class="form-label" for="">{{
                        $t("profiles.speed_limit")
                      }}</label>
                      <div class="row">
                        <div class="col-sm-6">
                          <div
                            class="form-check custom-option custom-option-basic"
                          >
                            <label
                              class="form-check-label custom-option-content"
                              for="opspeed"
                            >
                              <input
                                name="openprofilespeed"
                                class="form-check-input"
                                type="checkbox"
                                v-model="profile.has_open_speed"
                                @input="validate"
                              />
                              <span class="custom-option-header">
                                <span class="h6 mb-0 d-flex align-items-center"
                                  ><i class="ti ti-brand-speedtest me-1"></i
                                  >{{ $t("profiles.open_speed") }}</span
                                >
                              </span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-12" v-if="profile.has_open_speed">
                      <div class="row">
                        <div class="col-sm-6 mt-3">
                          <label class="form-label" for="">{{
                            $t("profiles.start_hour")
                          }}</label>
                          <select
                            class="form-select w-100"
                            data-style="btn-default"
                            v-model="profile.open_start_hour"
                            @change="validate"
                          >
                            <option
                              v-for="hour in hours"
                              :key="hour.id"
                              :value="hour.id"
                              >{{ hour.name }}</option
                            >
                          </select>
                        </div>
                        <div class="col-sm-6 mt-3">
                          <label class="form-label" for="">{{
                            $t("profiles.stop_hour")
                          }}</label>
                          <select
                            class="form-select w-100"
                            data-style="btn-default"
                            v-model="profile.open_stop_hour"
                            @change="validate"
                          >
                            <option
                              v-for="hour in hours"
                              :key="hour.id"
                              :value="hour.id"
                              >{{ hour.name }}</option
                            >
                          </select>
                        </div>
                        <div class="col-sm-6 mt-3">
                          <label class="form-label" for="">{{
                            $t("profiles.open_download")
                          }}</label>
                          <input
                            type="number"
                            class="form-control"
                            id="basic-url33"
                            aria-describedby="basic-addon34"
                            :placeholder="$t('profiles.open_download')"
                            v-model="profile.open_download_rate_mb"
                            @input="validate"
                          />
                        </div>
                        <div class="col-sm-6 mt-3">
                          <label class="form-label" for="">{{
                            $t("profiles.open_upload")
                          }}</label>
                          <input
                            type="number"
                            class="form-control"
                            id="basic-url34"
                            aria-describedby="basic-addon34"
                            :placeholder="$t('profiles.open_upload')"
                            v-model="profile.open_upload_rate_mb"
                            @input="validate"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-12 d-flex justify-content-between">
                      <button class="btn btn-label-secondary btn-prev">
                        <i class="ti ti-arrow-left ti-xs me-sm-2"></i>
                        <span
                          @click.prevent="previousStep"
                          class="align-middle d-sm-inline-block d-none"
                          >{{ $t("control.previous") }}</span
                        >
                      </button>
                      <div class="d-flex gap-x-2">
                        <button
                          @click.prevent="store"
                          :disabled="!validated"
                          class="btn btn-success"
                          v-if="profile.id"
                        >
                          <span
                            class="align-middle d-sm-inline-block d-none me-sm-2"
                            >{{ $t("control.save_and_close") }}</span
                          >
                          <i class="ti ti-check ti-xs"></i>
                        </button>
                        <button
                          @click.prevent="nextStep"
                          class="btn btn-primary btn-next"
                        >
                          <span
                            class="align-middle d-sm-inline-block d-none me-sm-2"
                            >{{ $t("control.next") }}</span
                          >
                          <i class="ti ti-arrow-right ti-xs"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Social Links -->
                <div id="other-info" class="content">
                  <div class="row g-6">
                    <div class="col-12">
                      <label class="form-label" for="">{{
                        $t("profiles.shared_note")
                      }}</label>
                      <div class="row">
                        <div class="col-sm-6">
                          <div
                            class="form-check custom-option custom-option-basic"
                          >
                            <label
                              class="form-check-label custom-option-content"
                              for="sharedmikrotik"
                            >
                              <input
                                name="mikrotikshared"
                                class="form-check-input"
                                type="radio"
                                :value="1"
                                v-model="profile.shared"
                                id="sharedmikrotik"
                                @input="validate"
                              />
                              <span class="custom-option-header">
                                <span class="h6 mb-0 d-flex align-items-center"
                                  ><i class="ti ti-share me-1"></i
                                  >{{ $t("profiles.shared") }}</span
                                >
                              </span>
                            </label>
                          </div>
                        </div>
                        <div class="col-sm-6 mt-2 mt-md-0">
                          <div
                            class="form-check custom-option custom-option-basic"
                          >
                            <label
                              class="form-check-label custom-option-content"
                              for="notsharedmikrotik"
                            >
                              <input
                                name="mikrotikshared"
                                class="form-check-input"
                                type="radio"
                                :value="0"
                                v-model="profile.shared"
                                id="notsharedmikrotik"
                                @input="validate"
                              />
                              <span class="custom-option-header">
                                <span class="h6 mb-0 d-flex align-items-center"
                                  ><i class="ti ti-share-off me-1"></i
                                  >{{ $t("profiles.shared_false") }}</span
                                >
                              </span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="col-12"
                      :class="{
                        'border-2 border-danger rounded-xl':
                          errors.allowed_nases,
                      }"
                    >
                      <!-- <label for="flatpickr-datetime" class="form-label">{{
                        $t("profiles.allowed_nases")
                      }}</label>

                      <div class="select2-primary">
                        <multiselect
                          v-model="allowed_nases"
                          :options="nases"
                          :close-on-select="false"
                          :trackBy="'value'"
                          :label="'label'"
                          :searchable="false"
                          :taggable="true"
                          :multiple="true"
                          :hideSelected="true"
                        ></multiselect>
                      </div> -->
                      <h5 class="card-header m-0">
                        <div class="d-inline-block">
                          <input
                            type="checkbox"
                            @input="checkAll(nases, allowed_nases)"
                            @change="validate"
                            v-model="allowed_nases.checkAll"
                            class="form-check-input"
                          />
                        </div>
                        <label for=""
                          ><h4 class="mx-1 my-4">
                            {{ $t("profiles.allowed_nases") }}
                          </h4></label
                        >
                      </h5>
                      <hr class="m-0" />
                      <div class="row gap-y-5 gap-x-0 mt-1 ">
                        <div
                          class="col-12 col-md-4"
                          v-for="(nas, index) in nases"
                          :key="index"
                          v-memo="[allowed_nases.length]"
                        >
                          <input
                            type="checkbox"
                            class="form-check-input"
                            @change="validate"
                            :name="nas.value"
                            :id="nas.value"
                            :value="nas"
                            v-model="allowed_nases"
                          />
                          <label :for="nas.value">{{ nas.label }}</label>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="input-group">
                        <span class="input-group-text">{{
                          $t("profiles.ip_pool")
                        }}</span>
                        <div class="input-group-text">
                          <input
                            class="form-check-input mt-0"
                            type="checkbox"
                            v-model="ip_pool_enabled"
                            aria-label="Checkbox for following text input"
                            @input="
                              fetch_pools();
                              validate();
                            "
                          />
                        </div>
                        <select
                          id="selectpickerBasic6"
                          class="form-select"
                          data-style="btn-default"
                          v-model="profile.ip_pool"
                          @change="validate"
                        >
                          <option>{{ $t("profiles.select_nas") }}</option>
                          <option
                            v-for="pool in pools"
                            v-bind:key="pool.id"
                            :value="pool.name"
                          >
                            {{ pool.name }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div
                      class="col-12"
                      v-if="hasPrivilege('admins_assign_profiles')"
                    >
                      <!-- <label for="flatpickr-datetime" class="form-label">{{
                        $t("profiles.allowed_admins")
                      }}</label>

                      <div class="select2-primary">
                        <multiselect
                          v-model="allowed_admins"
                          :options="admins"
                          :close-on-select="false"
                          :trackBy="'value'"
                          :label="'label'"
                          :searchable="false"
                          :taggable="true"
                          :multiple="true"
                          :hideSelected="true"
                        ></multiselect>
                      </div> -->
                      <h5 class="card-header m-0">
                        <div class="d-inline-block">
                          <input
                            type="checkbox"
                            @input="checkAll(admins, allowed_admins)"
                            v-model="allowed_admins.checkAll"
                            class="form-check-input"
                          />
                        </div>
                        <label for=""
                          ><h4 class="mx-1 my-4">
                            {{ $t("profiles.allowed_admins") }}
                          </h4></label
                        >
                      </h5>
                      <hr class="m-0" />
                      <div class="row gap-y-5 gap-x-0 mt-1">
                        <div
                          class="col-12 col-md-4"
                          v-for="(admin, index) in admins"
                          :key="index"
                          v-memo="[allowed_admins.length]"
                        >
                          <input
                            type="checkbox"
                            class="form-check-input"
                            :name="admin.value"
                            :id="admin.value"
                            :value="admin"
                            v-model="allowed_admins"
                          />
                          <label :for="admin.value">{{ admin.label }}</label>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <label class="form-label" for="">{{
                        $t("profiles.resellers_allowed_sessions")
                      }}</label>
                      <input
                        type="number"
                        class="form-control"
                        id="basic-url35"
                        aria-describedby="basic-addon34"
                        v-model="profile.resellers_allowed_sessions"
                        :placeholder="$t('profiles.resellers_allowed_sessions')"
                        @input="validate"
                      />
                    </div>
                    <div class="col-6 flex flex-col justify-between">
                      <label class="form-label" for="">{{
                        $t("profiles.app_allowed_note")
                      }}</label>
                      <div class="row">
                        <div class="">
                          <div
                            class="form-check custom-option custom-option-basic"
                          >
                            <label
                              class="form-check-label custom-option-content"
                              for="appallowed"
                            >
                              <input
                                name="apppermissions"
                                class="form-check-input"
                                type="checkbox"
                                id="appallowed"
                                v-model="profile.app_allowed"
                                @change="validate"
                              />
                              <span class="custom-option-header">
                                <span class="h6 mb-0 d-flex align-items-center"
                                  ><i class="ti ti-world-check me-1"></i
                                  >{{ $t("profiles.app_allowed") }}</span
                                >
                              </span>
                              <div
                                v-if="errors.app_allowed_zero_profile"
                                class="text-danger text-sm"
                              >
                                {{ errors.app_allowed_zero_profile }}
                              </div>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-6 flex flex-col justify-between">
                      <label class="form-label" for="">{{
                        $t("profiles.expiration_profile")
                      }}</label>
                      <div class="row">
                        <div class="mt-2 mt-md-0">
                          <div
                            class="form-check custom-option custom-option-basic"
                          >
                            <label
                              class="form-check-label custom-option-content"
                              for="yesexprofile"
                            >
                              <input
                                name="exprofile"
                                class="form-check-input"
                                type="checkbox"
                                v-model="profile.has_expiration_profile"
                                id="yesexprofile"
                                @input="validate"
                              />
                              <span class="custom-option-header">
                                <span
                                  class="h6 mb-0 d-flex align-items-center"
                                  >{{ $t("profiles.expiration_profile") }}</span
                                >
                              </span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-12" v-if="profile.has_expiration_profile">
                      <label class="form-label" for="">{{
                        $t("profiles.expiration_profile_note")
                      }}</label>
                      <div class="input-group input-group-merge">
                        <span class="input-group-text">{{
                          $t("profiles.expiration_profile_message")
                        }}</span>
                        <textarea
                          class="form-control"
                          aria-label="Notes"
                          v-model="profile.expiration_profile_message"
                          @input="validate"
                        ></textarea>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="input-group">
                        <span class="input-group-text">{{
                          $t("profiles.custom_attributes")
                        }}</span>
                        <textarea
                          v-model="profile.custom_attributes"
                          class="form-control"
                          aria-label="Notes"
                          dir="auto"
                          @input="validate"
                        ></textarea>
                      </div>
                    </div>
                    <div class="col-12">
                      <div v-if="errors.name" class="invalid-feedback">
                        {{ errors.name }}
                      </div>
                      <div v-if="errors.upload" class="invalid-feedback">
                        {{ errors.upload }}
                      </div>
                      <div v-if="errors.download" class="invalid-feedback">
                        {{ errors.download }}
                      </div>
                      <div
                        v-if="errors.expiration_profile_speed"
                        class="invalid-feedback"
                      >
                        {{ errors.expiration_profile_speed }}
                      </div>
                      <div
                        v-if="errors.shared_download"
                        class="invalid-feedback"
                      >
                        {{ errors.shared_download }}
                      </div>
                      <div v-if="errors.shared_upload" class="invalid-feedback">
                        {{ errors.shared_upload }}
                      </div>
                      <div v-if="errors.nas" class="invalid-feedback">
                        {{ errors.nas }}
                      </div>
                    </div>

                    <div class="col-12 d-flex justify-content-between">
                      <button class="btn btn-label-secondary btn-prev">
                        <i class="ti ti-arrow-left ti-xs me-sm-2"></i>
                        <span
                          @click.prevent="previousStep"
                          class="align-middle d-sm-inline-block d-none"
                          >{{ $t("control.next") }}</span
                        >
                      </button>
                      <button
                        class="btn btn-success"
                        @click.prevent="store"
                        :disabled="!validated"
                      >
                        {{
                          profile.id ? $t("control.update") : $t("control.add")
                        }}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="flex justify-end">
            <InfoButton :url="'https://www.youtube.com/watch?v=e7gW226Y754'" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { mapGetters, mapState } from "vuex";
import { hasPrivilege } from "../../global_constants";
export default {
  name: "AddProfile",
  computed: {
    ...mapGetters(["user", "settings"]),
  },
  data() {
    return {
      error: "",
      message: "",
      has_static_ip: false,
      limit_factor: 1,
      download_rate_limit_factor: 1024,
      upload_rate_limit_factor: 1024,
      expiration_rate_limit_factor: 1024,
      has_expiration_proxy: false,
      loading: false,
      showOpenDialog: false,
      profile: {
        name: "",
        service: "any",
        type: "subscribtion",
        enabled: true,
        shared: false,
        price: 0,
        download_rate_kb: 0,
        upload_rate_kb: 0,
        has_expiration: true,
        fixed_expiration: "",
        expiration_unit: "months",
        expiration_value: 1,
        traffic_limited: false,
        traffic_limit_value_mb: 0,
        allowed_admins: [],
        allowed_nases: [],
        ip_pool: "",
        custom_attributes: "",
        resellers_allowed_sessions: 1,
        has_open_speed: false,
        open_start_hour: 2,
        open_stop_hour: 6,
        open_upload_rate_mb: 10,
        open_download_rate_mb: 10,
        shared_download_rate_kb: 512,
        shared_upload_rate_kb: 512,
        has_expiration_profile: false,
        expiration_profile_speed: 5,
        expiration_profile_message:
          "لقد انتهى اشتراكك في شبكتنا يرجى مراجعة مركز الشبكة لتفعيل الاشتراك",
        app_allowed: false,
        description: null,
      },
      hours: [
        { name: "00:00 AM", id: "0" },
        { name: "01:00 AM", id: "1" },
        { name: "02:00 AM", id: "2" },
        { name: "03:00 AM", id: "3" },
        { name: "04:00 AM", id: "4" },
        { name: "05:00 AM", id: "5" },
        { name: "06:00 AM", id: "6" },
        { name: "07:00 AM", id: "7" },
        { name: "08:00 AM", id: "8" },
        { name: "09:00 AM", id: "9" },
        { name: "10:00 AM", id: "10" },
        { name: "11:00 AM", id: "11" },
        { name: "12:00 PM", id: "12" },
        { name: "13:00 PM", id: "13" },
        { name: "14:00 PM", id: "14" },
        { name: "15:00 PM", id: "15" },
        { name: "16:00 PM", id: "16" },
        { name: "17:00 PM", id: "17" },
        { name: "18:00 PM", id: "18" },
        { name: "19:00 PM", id: "19" },
        { name: "20:00 PM", id: "20" },
        { name: "21:00 PM", id: "21" },
        { name: "22:00 PM", id: "22" },
        { name: "23:00 PM", id: "23" },
      ],
      unlimited_speed: false,
      ip_pool_enabled: false,
      pools: [],
      profiles: null,
      nases: [],
      allowed_nases: [],
      allowed_admins: [],
      admins: [],
      errors: {
        name: null,
        download: null,
        upload: null,
        nas: null,
        shared_download: null,
        shared_upload: null,
        expiration_profile_speed: null,
        allowed_nases: null,
        app_allowed_zero_profile: null,
      },
      validated: false,
    };
  },
  mounted() {
    this.stepper = new Stepper(document.querySelector(".bs-stepper"), {
      linear: true,
      animation: false,
      selectors: {
        steps: ".step",
        trigger: ".step-trigger",
        stepper: ".bs-stepper",
      },
    });
  },
  async created() {
    this.loading = true;
    if (this.hasPrivilege("nases_view_index_nases")) {
      await this.fetchNases();
    }
    if (
      this.hasPrivilege("admins_view_index_admins") ||
      this.hasPrivilege("admins_view_search_admins")
    ) {
      await this.fetchAdmins();
    }

    if (this.$route.query.profile_id) {
      await this.fetchProfile(this.$route.query.profile_id);
      this.validated = true;
    } else {
      var temp = [];
      this.nases.forEach((element) => {
        temp.push(element);
      });
      this.allowed_nases = temp;
      this.allowed_nases.checkAll = true;
      var temp = [];
      this.admins.forEach((element) => {
        temp.push(element);
      });
      this.allowed_admins = temp;
      this.allowed_admins.checkAll = true;
    }
    if (this.settings.expiration_profile_message) {
      this.profile.expiration_profile_message = this.settings.expiration_profile_message;
    }
    if (this.$route.query.operation == "copy") {
      this.profile.id = null;
      this.profile.name = "";
    }
    this.loading = false;
    if (this.stepper) this.stepper.to(1);
  },
  // watch: {
  //   $route(to, from) {
  //     if (this.$route.params.id == null) {
  //       this.profile = {
  //         name: "",
  //         service: "any",
  //         type: "subscribtion",
  //         enabled: true,
  //         shared: false,
  //         price: 0,
  //         download_rate_kb: 0,
  //         upload_rate_kb: 0,
  //         has_expiration: false,
  //         fixed_expiration: "",
  //         expiration_unit: "months",
  //         expiration_value: 0,
  //         traffic_limited: false,
  //         traffic_limit_value_mb: 0,
  //         ip_pool: "",
  //         custom_attributes: "",
  //       };
  //     }
  //   },
  // },
  methods: {
    hasPrivilege(privilege) {
      return hasPrivilege(this.user, privilege);
    },
    async store() {
      this.loading = true;
      if (!this.ip_pool_enabled) this.profile.ip_pool = null;
      if (this.unlimited_speed) {
        this.profile.download_rate_kb = -1;
        this.profile.upload_rate_kb = -1;
      }
      var temp1 = [];
      this.allowed_admins.forEach((element) => {
        temp1.push(element.value);
      });
      this.allowed_admins = temp1;
      temp1 = [];
      this.allowed_nases.forEach((element) => {
        temp1.push(element.value);
      });
      this.allowed_nases = temp1;
      if (this.profile.id) {
        const response = await axios.put(`/profiles/${this.profile.id}`, {
          name: this.profile.name,
          service: this.profile.service,
          type: this.profile.type,
          enabled: this.profile.enabled ? 1 : 0,
          price: this.profile.price,
          download_rate_kb:
            this.profile.download_rate_kb * this.download_rate_limit_factor,
          upload_rate_kb:
            this.profile.upload_rate_kb * this.upload_rate_limit_factor,
          has_expiration: this.profile.has_expiration,
          fixed_expiration: this.profile.fixed_expiration,
          expiration_unit: this.profile.expiration_unit,
          expiration_value: this.profile.expiration_value,
          traffic_limited: this.profile.traffic_limited,
          traffic_limit_value_mb:
            this.profile.traffic_limit_value_mb * this.limit_factor,
          ip_pool: this.profile.ip_pool,
          allowed_nases: this.allowed_nases,
          allowed_admins: this.allowed_admins,
          shared: this.profile.shared,
          custom_attributes: this.profile.custom_attributes,
          resellers_allowed_sessions: this.profile.resellers_allowed_sessions,
          has_open_speed: this.profile.has_open_speed,
          open_start_hour: this.profile.open_start_hour,
          open_stop_hour: this.profile.open_stop_hour,
          open_upload_rate_mb: this.profile.open_upload_rate_mb,
          open_download_rate_mb: this.profile.open_download_rate_mb,
          shared_download_rate_kb: this.profile.shared_download_rate_kb,
          shared_upload_rate_kb: this.profile.shared_upload_rate_kb,
          has_expiration_profile: this.profile.has_expiration_profile,
          expiration_profile_speed:
            this.profile.expiration_profile_speed *
            this.expiration_rate_limit_factor,
          expiration_profile_message: this.profile.expiration_profile_message,
          app_allowed: this.profile.app_allowed,
          description: this.profile.description,
        });
        if (response.status == 200) {
          document.getElementById("add-profile-close").click();
          if (this.profile.id)
            this.$notify({
              text: this.$t("messages.profile_updated_successfully"),
              type: "success",
            });
          else
            this.$notify({
              text: this.$t("messages.profile_added_successfully"),
              type: "success",
            });
          this.$emit("updated");
        }
      } else {
        const response = await axios.post("/profiles", {
          name: this.profile.name,
          service: this.profile.service,
          type: this.profile.type,
          enabled: this.profile.enabled ? 1 : 0,
          price: this.profile.price,
          download_rate_kb:
            this.profile.download_rate_kb * this.download_rate_limit_factor,
          upload_rate_kb:
            this.profile.upload_rate_kb * this.upload_rate_limit_factor,
          has_expiration: this.profile.has_expiration,
          fixed_expiration: this.profile.fixed_expiration,
          expiration_unit: this.profile.expiration_unit,
          expiration_value: this.profile.expiration_value,
          traffic_limited: this.profile.traffic_limited,
          traffic_limit_value_mb:
            this.profile.traffic_limit_value_mb * this.limit_factor,
          ip_pool: this.profile.ip_pool,
          allowed_nases: this.allowed_nases,
          allowed_admins: this.allowed_admins,
          shared: this.profile.shared,
          custom_attributes: this.profile.custom_attributes,
          resellers_allowed_sessions: this.profile.resellers_allowed_sessions,
          has_open_speed: this.profile.has_open_speed,
          open_start_hour: this.profile.open_start_hour,
          open_stop_hour: this.profile.open_stop_hour,
          open_upload_rate_mb: this.profile.open_upload_rate_mb,
          open_download_rate_mb: this.profile.open_download_rate_mb,
          shared_download_rate_kb: this.profile.shared_download_rate_kb,
          shared_upload_rate_kb: this.profile.shared_upload_rate_kb,
          has_expiration_profile: this.profile.has_expiration_profile,
          expiration_profile_speed:
            this.profile.expiration_profile_speed *
            this.expiration_rate_limit_factor,
          expiration_profile_message: this.profile.expiration_profile_message,
          app_allowed: this.profile.app_allowed,
          description: this.profile.description,
        });
        if (response.status == 200) {
          document.getElementById("add-profile-close").click();
          this.$notify({
            text: "Profile Added Successfully",
            type: "success",
          });
          this.$emit("updated");
        } else if (response.status == 210) {
          this.errors.name = this.$t("errors.profiles.name_taken");
          this.validated = false;
        }
      }
      this.loading = false;
    },
    async fetchProfile(id) {
      const response = await axios.get(`profiles/${id}`);
      if (response.status == 200) {
        this.profile = response.data.data;
        this.profile.enabled = this.profile.enabled == 1;
        if (this.hasPrivilege("nases_view_index_nases")) {
          this.profile.allowed_nases.forEach((element) => {
            this.allowed_nases.push({
              value: element.id,
              label: element.shortname,
            });
          });
        }
        if (
          this.hasPrivilege("admins_view_index_admins") ||
          this.hasPrivilege("admins_view_search_admins")
        ) {
          this.profile.allowed_admins.forEach((element) => {
            this.allowed_admins.push({
              value: element.id,
              label: element.email,
            });
          });
        }
        if (this.profile.download_rate_kb > 1023) {
          this.profile.download_rate_kb = this.profile.download_rate_kb / 1024;
        } else {
          this.download_rate_limit_factor = 1;
        }
        if (this.profile.upload_rate_kb > 1023) {
          this.profile.upload_rate_kb = this.profile.upload_rate_kb / 1024;
        } else {
          this.upload_rate_limit_factor = 1;
        }
        if (this.profile.expiration_profile_speed > 1023) {
          this.profile.expiration_profile_speed =
            this.profile.expiration_profile_speed / 1024;
        } else {
          this.expiration_rate_limit_factor = 1;
        }
      }
      if (this.profile.ip_pool) {
        this.ip_pool_enabled = true;
        this.fetch_pools();
        if (this.pools.length == 0) {
          this.pools.push({ id: "-1", name: this.profile.ip_pool });
        }
      }
      if (this.profile.download_rate_kb < 0) this.unlimited_speed = true;
    },
    async fetchNases() {
      const response = await axios.get("nases?itr=true&rows=10000000");
      response.data.data.forEach((element) => {
        this.nases.push({ value: element.id, label: element.shortname });
      });
    },
    async fetchAdmins() {
      const response = await axios.get(
        "admins?itr=true&type=resellers_admins&rows=10000000",
      );
      response.data.data.forEach((element) => {
        this.admins.push({ value: element.id, label: element.email });
      });
    },
    async fetch_pools() {
      this.loading = true;
      var nases = [];
      this.allowed_nases.forEach((element) => {
        nases.push(element.value);
      });
      const response = await axios.get(`nases/pools/${nases[0]}`);
      try {
        this.pools = response.data;
      } catch (error) {}
      this.loading = false;
    },
    toggleOpenSpeed() {
      if (
        !this.profile.has_open_speed &&
        (this.profile.shared || this.profile.custom_attributes != "")
      ) {
        this.showOpenDialog = true;
      } else if (!this.profile.has_open_speed) {
        this.profile.has_open_speed = true;
      } else {
        this.profile.has_open_speed = false;
      }
    },
    checkAll(data, model) {
      if (!model.checkAll) {
        data.forEach((element) => {
          model.push(element);
        });
      } else {
        model.splice(0, model.length);
      }
    },
    nextStep() {
      this.stepper.next();
    },
    previousStep() {
      this.stepper.previous();
    },
    goStep(num) {
      this.stepper.to(num);
    },
    validate() {
      const onlyNumbers = new RegExp("^[0-9]+$");
      this.validated = true;
      this.errors.name = null;
      this.errors.download = null;
      this.errors.upload = null;
      this.errors.nas = null;
      this.errors.shared_upload = null;
      this.errors.shared_download = null;
      this.errors.expiration_profile_speed = null;
      this.errors.allowed_nases = null;
      this.errors.app_allowed_zero_profile = null;

      if (this.profile.name == "") {
        this.errors.name = this.$t("errors.profiles.name_empty");
        this.validated = false;
      }
      if (this.profile.upload_rate_kb == 0 && !this.unlimited_speed) {
        this.errors.upload = this.$t("errors.profiles.speed_0");
        this.validated = false;
      }
      if (!onlyNumbers.test(this.profile.upload_rate_kb)) {
        this.errors.upload = this.$t("errors.profiles.not_number");
        this.validated = false;
      }
      if (this.profile.download_rate_kb == 0 && !this.unlimited_speed) {
        this.errors.download = this.$t("errors.profiles.speed_0");
        this.validated = false;
      }
      if (!onlyNumbers.test(this.profile.download_rate_kb)) {
        this.errors.download = this.$t("errors.profiles.not_number");
        this.validated = false;
      }
      if (this.allowed_nases.length < 1) {
        this.errors.nas = this.$t("errors.profiles.nases_1");
        this.errors.allowed_nases = this.$t("errors.profiles.nases_1");
        this.validated = false;
      }
      if (this.profile.shared_download_rate_kb == 0 && this.profile.shared) {
        this.errors.shared_download = this.$t("errors.profiles.speed_0");
        this.validated = false;
      }
      if (!onlyNumbers.test(this.profile.shared_download_rate_kb)) {
        this.errors.shared_download = this.$t("errors.profiles.not_number");
        this.validated = false;
      }
      if (this.profile.shared_upload_rate_kb == 0 && this.profile.shared) {
        this.errors.shared_upload = this.$t("errors.profiles.speed_0");
        this.validated = false;
      }
      if (!onlyNumbers.test(this.profile.shared_upload_rate_kb)) {
        this.errors.shared_upload = this.$t("errors.profiles.not_number");
        this.validated = false;
      }
      if (!onlyNumbers.test(this.profile.expiration_profile_speed)) {
        this.errors.expiration_profile_speed = this.$t(
          "errors.profiles.not_number",
        );
        this.validated = false;
      }
      if (this.profile.app_allowed && this.profile.price == 0) {
        this.errors.app_allowed_zero_profile = this.$t(
          "errors.profiles.app_allowed_zero_profile",
        );
      }
    },
    changeProfileTrafficLimit(value) {
      this.profile.traffic_limit_value_mb = value;
    },
  },
};
</script>
